import React, { ChangeEvent, KeyboardEvent, useState } from 'react';
import classes from "./Teacher.module.css"
import http from './../Service/http';
import { teacher } from './../store/teacher';
import Input from './../Components/Select/Input';
import { BsSearch } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';


function TeacherIntrument() {

    const [ name, setName ] = useState<string>("")
    const { t } = useTranslation();



    return ( 
        <div className={classes.teacher}>
            <div style={{ margin: "0 auto", width: "100%", display: "flex", alignItems: "flex-end", justifyContent: "center"}}>
            <Input type = {"search"}
                value={ name }
                oninput ={setName}  
                placeholder ={ ""}
                title = { t("st:instrument.titles.searchCustom") } 
                style={{ width: "480px"}}
                keyDown={ async(e: KeyboardEvent<HTMLInputElement>) => {
                    if(e.key == "Enter"){
                        const res = await http.get("/teacher/teacher-list?name=" + name)
                        teacher.newTeachers(res.data.TeacherList);
                        
                    }
                }} />
            <BsSearch className='search_icon' onClick={async() => {
                        const res = await http.get("/teacher/teacher-list?name=" + name)
                        teacher.newTeachers(res.data.TeacherList);
                }} />
        </div>
        </div>
     );
}

export default TeacherIntrument;